export default __webpack_public_path__ + "static/media/1854.26d5552a.png";